import { render, staticRenderFns } from "./GoogleBusinessSearch.vue?vue&type=template&id=b4da5066&scoped=true"
import script from "./GoogleBusinessSearch.vue?vue&type=script&lang=js"
export * from "./GoogleBusinessSearch.vue?vue&type=script&lang=js"
import style0 from "./GoogleBusinessSearch.vue?vue&type=style&index=0&id=b4da5066&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4da5066",
  null
  
)

export default component.exports